import { render, staticRenderFns } from "./productInquiry.vue?vue&type=template&id=028ed618&"
import script from "./productInquiry.vue?vue&type=script&lang=js&"
export * from "./productInquiry.vue?vue&type=script&lang=js&"
import style0 from "./productInquiry.vue?vue&type=style&index=0&id=028ed618&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports